module.exports = __webpack_public_path__ + "static/media/camera-icon.cda621db.svg";